import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { ForgotPasswordForm } from '../../forgot-password/models/forgot-password';
import { LoginForm, SmsForm } from '../../login/models/login.model';
import * as fromRegister from '../../register/actions/register';
import { CodeForm, MinimalRegisterForm } from '../../register/models/register.model';
import { User } from '../models/user';

@Injectable()
export class AuthService {
  captchaId: string;
  confirmationResult: any;
  recaptchaVerifier: firebase.auth.RecaptchaVerifier;

  constructor(public afAuth: AngularFireAuth, private store: Store<any>, private http: HttpClient) {
  }

  getCode({companyCode, userCode}: CodeForm) {

    return Observable.create(observer => {
      return this.http.get(`https://us-central1-spaq-156518.cloudfunctions.net/getCode?companyCode=${companyCode}&userCode=${userCode}`).subscribe(
        data => {
          if (data === null) {
            observer.error({code: 'not-found', message: 'Code introuvable'})
          } else {
            observer.next(data);
            observer.complete();
          }
        }, e => {
          observer.error(e);
        });
    });
  }

  clearCaptcha() {
    console.log('CAPTCHA CLEANE');
    this.confirmationResult = null;
    if (this.recaptchaVerifier) {
      this.recaptchaVerifier.clear();
    }
  }

  renderCaptcha() {

    const self = this;
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('captcha', {
      'size': 'invisible',
      'callback': (result) => {
        this.store.dispatch(new fromRegister.CaptchaCheckSuccess(result));
      },
      'expired-callback': () => {
        this.store.dispatch(new fromRegister.CaptchaExpire());
        //self.clearCaptcha();
      },
    });

    this.recaptchaVerifier.render().then(widgetId => {
      this.captchaId = widgetId;
      this.store.dispatch(new fromRegister.CaptchaInitSuccess(widgetId));

    }).catch((e) => {
      this.store.dispatch(new fromRegister.CaptchaInitFailure(new FirebaseError(e)));
    });

  }

  onCaptchaSolve(result) {
    this.store.dispatch(new fromRegister.CaptchaCheckSuccess(result));
  }

  onCaptchaExpire() {
    this.store.dispatch(new fromRegister.CaptchaExpire());
    this.clearCaptcha();
  }

  loginSms({phoneNumber, code}: SmsForm): Observable<any> {
    if (code) {
      // return Observable.of({uid: 12345});

      return Observable.create(observer => {
        this.confirmationResult.confirm(code).then(result => {
          console.log('C POUR CA');
          console.log(result);
          const user = {
            displayName: result.user.displayName,
            phoneNumber: result.user.phoneNumber,
            email: result.user.email,
            photoUrl: result.user.photoURL,
            emailVerified: result.user.emailVerified,
            uid: result.user.uid,
          } as User;
          this.clearCaptcha();
          observer.next(user);
          observer.complete();

        }).catch(e => {
          observer.error(new FirebaseError(e));
        });
      });
    }
    return Observable.create(observer => {
      this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('captcha', {
        'size': 'invisible',
        'callback': result => this.onCaptchaSolve,
        'expired-callback': _ => this.onCaptchaExpire,
      })
      this.recaptchaVerifier.render().then(widgetId => {
        this.captchaId = widgetId;
        this.store.dispatch(new fromRegister.CaptchaInitSuccess(widgetId));

      }).catch((e) => {
        this.store.dispatch(new fromRegister.CaptchaInitFailure(new FirebaseError(e)));
      });

      this.afAuth.auth.signInWithPhoneNumber('+1' + phoneNumber, this.recaptchaVerifier).then(r => {
        this.confirmationResult = r;
        observer.next(r);
        observer.complete();
      }).catch(e => {
        observer.error(new FirebaseError(e));
      });
    });
  }

  register({email, password}: MinimalRegisterForm) {
    return Observable.create(observer => {
      this.afAuth.auth.createUserWithEmailAndPassword(email, password).then(r => {
        const user = {
          displayName: r.displayName,
          phoneNumber: r.phoneNumber,
          email: r.email,
          photoUrl: r.photoURL,
          emailVerified: r.emailVerified,
          uid: r.uid,
        } as User;
        observer.next(user);
        observer.complete();
      }).catch(e => {
        console.log(e);
        observer.error(new FirebaseError(e));
      });
    });
  }

  logout() {
    return Observable.create(observer => {
      this.afAuth.auth.signOut().then(r => {
        observer.next(true);
        observer.complete();
      }).catch(e => {

        observer.error(new FirebaseError(e));
      });
    });
  }

  sendEmailVerificationLink() {
    return Observable.create(observer => {
      if (!this.afAuth.auth.currentUser) {
        observer.error(false);
        observer.complete();
      }
      this.afAuth.auth.currentUser.sendEmailVerification().then(_ => {
        observer.next(true)
        observer.complete();
      }).catch(e => observer.error(new FirebaseError(e)));
    })
    //return this.afAuth.auth.currentUser.sendEmailVerification();
  }

  sendPasswordResetEmail({email}: ForgotPasswordForm) {

    return Observable.create(observer => {
      this.afAuth.auth.sendPasswordResetEmail(email).then(e => {
        observer.next(true);
        observer.complete();
      }).catch(e => {
        observer.error(new FirebaseError(e));
      });
    }).map(e => {
      return e;
    });
  }

  resetPassword({password, code}) {

    return Observable.create(observer => {
      this.afAuth.auth.confirmPasswordReset(code, password).then(e => {
        observer.next({code, password});
        observer.complete();
      }).catch(e => {
        observer.error(new FirebaseError(e));
      });
    });

    /*
        return Observable.create(observer => {
          this.afAuth.auth.sendPasswordResetEmail(email).then(e => {
            observer.next(true);
            observer.complete();
          }).catch(e => {
            observer.error(e);
          });
        }).map(e => {
          return e;
        });
        */
  }

  forgotPassword(model) {
    return Observable.create(observer => {
      this.afAuth.auth.sendPasswordResetEmail(model.email, {url: 'https://mobile.spaq.e-korp.com/sdfdf/dsfdsfds/dsfsd'}).then(
        e => {
          observer.next(true);
          observer.complete();
        }).catch(e => {
        observer.error(new FirebaseError(e));
      })
    }).map(e => {
      return e;
    })
  }

  login({email, password}: LoginForm) {
    return Observable.create(observer => {
      this.afAuth.auth.signInWithEmailAndPassword(email, password).then(r => {
        const user = {
          displayName: r.displayName,
          phoneNumber: r.phoneNumber,
          email: r.email,
          photoUrl: r.photoURL,
          emailVerified: r.emailVerified,
          uid: r.uid,
        } as User;
        observer.next(user);
        observer.complete();
      }).catch(e => {
        observer.error(new FirebaseError(e));
      });
    });
  }
}

class FirebaseError {
  code: string;
  message: string;

  public constructor(error) {
    console.log(error);
    if (error.code) {
      this.code = error.code;
      this.message = this.translate(error);
    } else {
      this.code = 'internal';
      this.message = 'Une erreur interne est survenue. Réessayez plus tard.';
      console.log(error);
    }
  }

  translate({code, message}) {
    switch (code) {
      case 'auth/user-not-found':
        return 'Utilisateur inconnu';
      case 'auth/invalid-verification-id':
        return 'L\'identifiant de vérification est invalude.';
      case 'auth/invalid-verification-code':
        return 'Le code de vérification saisi est invalide.';
      case 'auth/wrong-password':
        return 'Le mot de passe saisi est incorrect.';
      case 'auth/invalid-email':
        return 'Cette adresse courriel est invalide.';
      case 'auth/email-already-in-use':
        return 'Ce courriel existe déjà parmi nos utilisateurs.';
      case 'auth/credential-already-in-use':
        return 'Le compte correspondant à l\'identifiant existe déjà parmi nos utilisateurs';
      case 'auth/invalid-credential':
        return 'Les informations d\'identification du fournisseur ne sont pas valides.';
      case 'auth/provider-already-linked':
        return 'Ce compte fournisseur est déjà lié à un utilisateur';
      case 'auth/invalid-phone-number':
        return 'Le numéro de téléphone est invalide.';
      case 'auth/captcha-check-failed':
        return 'Le captcha est invalide ou expiré';
      case 'auth/missing-phone-number':
        return 'Le numéro de téléphone est manquant';
      case 'auth/quota-exceeded':

        return 'La limite maximale est atteinte. Essayez à nouveau plus tard.';
      case 'auth/missing-continue-uri':
        return 'Adresse URL manquante.';
      case 'auth/invalid-continue-uri':
        return 'Adresse URL invalide';
      case 'auth/expired-action-code':
        return 'Le code d\'action est expiré';
      case 'auth/invalid-action-code':
        return 'Lien invalide ou expiré.';
      case 'auth/weak-password':
        return 'Le mot de passe doit contenir un minimum de 6 caractères';
      case 'xxxxxxxxxxxxxx':
        return 'yyyyyyyyyyyy';

      case 'xxxxxxxxxxxxxx':
        return 'yyyyyyyyyyyy';

      case 'xxxxxxxxxxxxxx':
        return 'yyyyyyyyyyyy';

      case 'xxxxxxxxxxxxxx':
        return 'yyyyyyyyyyyy';

      case 'xxxxxxxxxxxxxx':
        return 'yyyyyyyyyyyy';

      case 'xxxxxxxxxxxxxx':
        return 'yyyyyyyyyyyy';

      case 'xxxxxxxxxxxxxx':
        return 'yyyyyyyyyyyy';


      case 'auth/app-deleted':
        return 'Cette application a été supprimée';
      case 'auth/app-not-authorized':
        return 'Cette application n\'est pas autorisée';
      case 'auth/argument-error':
        return 'Cette méthode est appelée avec des arguments incorrects.';
      case 'auth/invalid-api-key':
        return 'La clé de l\'API est invalide.';
      case 'auth/invalid-user-token':
        return 'Les informations d\'identification ne sont plus valide. Reconnectez-vous à nouveau.';
      case 'auth/network-request-failed':
        return 'Un problème réseau s\'est produit';
      case 'auth/operation-not-allowed':
        return 'Cette opération n\'est pas autorisée';
      case 'auth/requires-recent-login':
        return 'Ce changement requiert une connexion récente. Reconnez-vous à votre compte puis essayez à nouveau.';
      case 'auth/too-many-requests':
        return 'Cette demande a été bloquée suite à une activité inhabituelle. Essayer de nouveau après quelques minutes.';
      case 'auth/unauthorized-domain':
        return 'Ce domaine d\'application n\'est pas autorisé';
      case 'auth/user-disabled':
        return 'Ce compte a été désactivé par un administrateur.';
      case 'auth/user-token-expired':
        return 'Les informations d\'identification de l\'utilisateur ont expiré ou l\'utilisateur a été supprimé.';
      case 'auth/web-storage-unsupported':
        return 'Le navigateur ne prend pas en charge le stockage Web.';
    }
  }
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/shared/services/auth.service.ts